<template>
  <div class="stripe-gateway">
    <StripeMethod
      :plan="plan"
      :period="period"
      :price="price"
    />
  </div>
</template>

<script>
import { AuthAPI } from '@/api';
import StripeMethod from '@/components/plans/StripeMethod';
export default {
  components: {
    StripeMethod,
  },
  created() {
    this.login();
  },
  methods: {
    async login() {
      const token = await AuthAPI.loginWithTempToken(this.token)
        .then(res => res.data.access_token);

      this.$store.commit('user/auth', token);
      await this.$store.dispatch('user/updateData')
    }
  },
  computed: {

    plan() {
      return this.$route.params.plan;
    },

    token() {
      return this.$route.params.token;
    },

    period() {
      return this.$route.params.period;
    },

    price() {
      const prices = {
        'impact': 11.15,

        'exact/month': 22.90,
        'premium/month': 49.00,
        'elite/month': 179.99,

        'exact/year': 229,
        'premium/year': 529,
        'elite/year': 1999,
      };

      if(this.plan === 'impact') {
        return prices[this.plan];
      } else {
        return prices[`${this.plan}/${this.period}`];
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.stripe-gateway {
  background: #fff;

  display: flex;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}

</style>
